<script setup>
import { ref } from 'vue'
import { useDetectDevice } from '@/composables/device'
import { useWebSiteStore } from '@/stores/website.store'

import SideBar from '@/components/shared/SideBar.vue'
import TopBar from '@/components/shared/TopBar.vue'
import BottomBar from '@/components/shared/BottomBar.vue'

const { isMobile } = useDetectDevice()

// Il menu parte APERTO da desktop e CHIUSO da mobile: su schermo grande resta sempre visibile e
// fa da navigazione, su telefono coprirebbe il contenuto.
const leftDrawerOpen = ref(!isMobile.value)

const websiteStore = useWebSiteStore()

const toggleLeftDrawer = () => {
  leftDrawerOpen.value = !leftDrawerOpen.value
}
</script>

<template>
  <q-layout
    v-if="!isMobile"
    view="hHh Lpr lff"
    style="min-height: auto;"
  >
    <top-bar
      :is-mobile="isMobile"
      :show-menu="websiteStore.isLogged()"
      @toggle="toggleLeftDrawer"
    />

    <side-bar
      v-if="websiteStore.isLogged()"
      v-model:is-open="leftDrawerOpen"
    />

    <q-page-container class="q-mx-md q-my-md">
      <router-view v-slot="{ Component }">
        <component :is="Component" />
      </router-view>
    </q-page-container>
  </q-layout>

  <q-layout
    v-else
    view="hHh lpr lFf"
    style="min-height: auto;"
  >
    <top-bar
      :is-mobile="isMobile"
      :show-menu="websiteStore.isLogged()"
      @toggle="toggleLeftDrawer"
    />

    <q-page-container>
      <router-view v-slot="{ Component }">
        <component :is="Component" />
      </router-view>
    </q-page-container>

    <bottom-bar v-if="websiteStore.isLogged()" />
  </q-layout>
</template>
